import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

function normalizeAxiosError(e) {
    return e?.response?.data?.error || e?.message || "Unbekannter Fehler";
}

export default function useRegions() {
    const [regions, setRegions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchRegions = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const res = await axios.get(`${API_BASE}/api/regions`, { withCredentials: true });
            setRegions(Array.isArray(res.data) ? res.data : []);
        } catch (e) {
            setError(normalizeAxiosError(e));
        } finally {
            setLoading(false);
        }
    }, []);

    const createRegion = useCallback(async (payload) => {
        try {
            const res = await axios.post(`${API_BASE}/api/regions`, payload, { withCredentials: true });
            await fetchRegions();
            return res.data?.region;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchRegions]);

    const updateRegion = useCallback(async (id, payload) => {
        try {
            const res = await axios.put(`${API_BASE}/api/regions/${id}`, payload, { withCredentials: true });
            await fetchRegions();
            return res.data?.region;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchRegions]);

    const deleteRegion = useCallback(async (id) => {
        try {
            await axios.delete(`${API_BASE}/api/regions/${id}`, { withCredentials: true });
            await fetchRegions();
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchRegions]);

    useEffect(() => {
        fetchRegions();
    }, [fetchRegions]);

    return {
        regions,
        loading,
        error,
        fetchRegions,
        createRegion,
        updateRegion,
        deleteRegion,
    };
}
